import { Text } from '@chakra-ui/react';
import { ISavedFilterSets, ITags } from '@publishing-engine/domain/models';
import { IDashboardSubmissionConfigResponse } from '@publishing-engine/domain/types';
import { getMatchedNames } from 'src/utils/matchedNames';
interface Props {
  saveFilters: ISavedFilterSets;
  availableFilters:
    | IDashboardSubmissionConfigResponse['filters']
    | null
    | undefined;
  manageTags: ITags[];
  /**
   * Field catalogue used to label advanced-search criteria in the summary.
   * Optional so views without advanced search can keep using this component.
   */
  advancedSearchFields?: IDashboardSubmissionConfigResponse['advancedSearchFields'];
}
const SaveFilterText: React.FC<Props> = ({
  saveFilters,
  availableFilters,
  manageTags,
  advancedSearchFields
}) => {
  const MatchString = availableFilters
    ? getMatchedNames(
        availableFilters,
        saveFilters,
        manageTags,
        advancedSearchFields
      )
    : '';

  return (
    <Text textStyle="textBody" isTruncated>
      {MatchString}
    </Text>
  );
};
export default SaveFilterText;
